import { Stack, Typography, Divider } from "@mui/material";

export default function Main({ link, set_link, links }) {
  return (
    <Stack sx={sx.wrapper}>
      <Stack direction="row" spacing={2}>
        {links.map((e, i) => {
          const sx_btn = {
            ...sx.btn,
            color: `${link.title === e.title ? "black" : "grey"}`,
          };
          return (
            <Typography key={i} sx={sx_btn} onClick={() => set_link(e)}>
              {e.title}
            </Typography>
          );
        })}
      </Stack>
      <Divider flexItem />
    </Stack>
  );
}

const sx = {
  wrapper: {
    width: 1,
    alignItems: "center",
  },
  btn: {
    p: 1,
    cursor: "pointer",
    "&:hover": { color: "black" },
  },
};
